import React, { useState, useEffect, FC } from "react";
import { Modal, Row, Col, Form, Input, InputNumber, Space, Switch } from "antd";
import { useGlobalState, useGlobalDispatch } from "../../context/Provider";
import { AddWarehouse, EditWarehouse } from "../../api/warehouse";
import {
  addWarehosuer,
  editWarehouse,
} from "../../context/warehouse/warehouse.action";

interface CollectionCreateFormProps {
  visible: boolean;
  setVisible: (value: boolean) => void;
  info: any;
  setInfo: (value: object) => void;
}

const ActionWarehouseModal: FC<CollectionCreateFormProps> = (props) => {
  const { langState }: any = useGlobalState();
  const { visible, setVisible, info, setInfo } = props;
  const [isEdit, setIsEdit] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { warehouserListDispatch: dispatch }: any = useGlobalDispatch();

  const [form] = Form.useForm();
  const {
    name,
    adminComment,
    isPrivate,
    onlyAccessibleByEmail,
    orderSelector,
    orderToShipmentTimeIntervalInHours,
    otS_Hours,
    sendNotificationOnPurchase,
  }: any = info;

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setInfo({});
    setIsEdit(false);
  };

  const onCreate = (values: any) => {
    setConfirmLoading(true);

    const id: number = info.id;
    const params = {
      name: values.name ? values.name : info.name,
      adminComment: values.adminComment,
      orderSelector: values.orderSelector,
      otS_Hours: values.otS_Hours,
      sendNotificationOnPurchase: values.sendNotificationOnPurchase,
      isPrivate: values.isPrivate,
      orderToShipmentTimeIntervalInHours:
        values.orderToShipmentTimeIntervalInHours,
      onlyAccessibleByEmail: values.onlyAccessibleByEmail,
      addressId: info.addressId,
    };

    if (isEdit) {
      EditWarehouse(params, id).then((res: any) => {
        setConfirmLoading(false);
        if (res.status === 200) {
          setInfo({});
          setVisible(false);
          dispatch(editWarehouse({ item: res.data }));
          form.resetFields();
        }
      });
    } else {
      AddWarehouse(params).then((res: any) => {
        setConfirmLoading(false);
        if (res.status === 200) {
          setInfo({});
          setVisible(false);
          dispatch(addWarehosuer({ list: res.data }));
          form.resetFields();
        }
      });
    }
  };

  const loadProfile = () => {
    form.setFieldsValue({
      adminComment: adminComment,
      orderSelector,
      otS_Hours,
      onlyAccessibleByEmail,
      orderToShipmentTimeIntervalInHours,
      isPrivate,
      sendNotificationOnPurchase,
    });
  };

  const locadCreateProfile = () => {
    form.setFieldsValue({
      otS_Hours: 0,
      orderSelector: 0,
      orderToShipmentTimeIntervalInHours: 0,
      isPrivate: false,
      sendNotificationOnPurchase: false,
      adminComment: "",
      onlyAccessibleByEmail: "",
    });
  };

  useEffect(() => {
    var size = Object.keys(info).length;
    // console.log("size", size);
    if (size) {
      loadProfile();
      setIsEdit(true);
    } else {
      locadCreateProfile();
      setIsEdit(false);
    }
  }, [info]);
  return (
    <Modal
      title={
        isEdit
          ? langState.locale === "en-US"
            ? `Warehouhse name : ${name}`
            : ` نام انبار : ${name}`
          : langState.locale === "en-US"
          ? "new warehouse"
          : "انبار جدید"
      }
      visible={visible}
      width={700}
      // onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={confirmLoading}
      onOk={(value: any) => {
        form.validateFields().then((values) => {
          // form.resetFields();
          onCreate(values);
        });
      }}
    >
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            name="form_in_modal"
            initialValues={{ modifier: "public" }}
          >
            {!isEdit && (
              <Form.Item
                name="name"
                label={
                  langState.locale === "en-US" ? "warehouseName" : " نام انبار"
                }
              >
                <Input />
              </Form.Item>
            )}

            <Form.Item
              name="adminComment"
              label={langState.locale === "en-US" ? "AdminComment" : " یادداشت"}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="onlyAccessibleByEmail"
              label={langState.locale === "en-US" ? "Email" : " ایمیل"}
              rules={[{ type: "email" }]}
            >
              <Input />
            </Form.Item>
            <Space>
              <Form.Item
                label={
                  langState.locale === "en-US"
                    ? "Order Selector"
                    : " اولویت انبار"
                }
                name="orderSelector"
              >
                <InputNumber min={0} max={100000} />
              </Form.Item>
              <Form.Item
                label={
                  langState.locale === "en-US" ? "Ots_Hours" : " زمان کلی ارسال"
                }
                name="otS_Hours"
              >
                <InputNumber min={0} max={100000} />
              </Form.Item>
              <Form.Item
                label={
                  langState.locale === "en-US"
                    ? "orderToShipmentTimeIntervalInHours"
                    : " زمان ارسال"
                }
                name="orderToShipmentTimeIntervalInHours"
              >
                <InputNumber min={0} max={100000} />
              </Form.Item>
            </Space>
            <Space>
              <Form.Item
                name="sendNotificationOnPurchase"
                label={
                  langState.locale === "en-US"
                    ? "notifiacation"
                    : "ارسال نوتیفیکیشن"
                }
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
              <Form.Item
                name="isPrivate"
                label={
                  langState.locale === "en-US" ? "isPrivate" : "انبار خصوصی"
                }
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Space>
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};

export default ActionWarehouseModal;
